import { IOrganization } from "organizations/models";

export const buildDashboardPath = (organization?: IOrganization) =>
  organization
    ? `/${organization.tenantId}/organizations/${organization.id}/dashboard`
    : "/";

export const buildSettingsPath = (tenantId?: string) =>
  tenantId ? `/${tenantId}/settings` : "/";

/** @deprecated Use buildSettingsPath instead */
export const buildDashboardSettingsPath = (organization?: IOrganization) =>
  buildSettingsPath(organization?.tenantId);

export const buildOrganizationSectionPath = (organization: IOrganization | undefined, section: string) =>
  organization ? `/${organization.tenantId}/organizations/${organization.id}/${section}` : "/";

export const buildOrganizationsPath = (tenantId: string | undefined) => {
  return tenantId ? `/${tenantId}/organizations` : "/";
};

export const buildAdminPath = (tenantId: string | undefined) =>
  tenantId ? `/${tenantId}/admin` : "/";
